// 接入腾讯云呼叫中心
import {
  getTcccURL,
  getSkillGroupId,
  getCallerInfo,
  isRegisterPhone,
  getSkillGroup
} from '@/api/login'
import { notification, Modal, message as Message, message } from 'ant-design-vue'
import store from '@/store'
import head_p from '@/assets/img/chat/head_p.png'
import head_d from '@/assets/img/chat/head_d.png'
import head_a from '@/assets/img/chat/head_a.png'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { createVNode, ref } from 'vue'
import { roleMap } from '@/components/Tccc/config'
import { joinActiveFollowupPairs } from '@/api/UserPool'

const headerObj = {
  患者: head_p,
  医生: head_d,
  BD: head_a
}
export const stutas = ref('init')
let sessionId = ''
export const initIccc = () => {
  getTcccURL().then(res => {
    const SdkURL = res
    if (res) {
      injectTcccWebSDK(SdkURL)
        .then(() => {
          stutas.value = 'ready'
          // 将初始化状态存储到store中
        })
        .catch(msg => {
          stutas.value = 'init'
          notification.error({
            message: '网络错误',
            description: msg
          })
        })
    } else {
      stutas.value = 'init'
    }
  })
}
function checkDevicesIsOK() {
  // 接打电话前。手动设置坐席为在线状态
  window.tccc.Agent.online()
  const envCheck = new Promise((resolve, reject) => {
    const isBrowserSupported = window.tccc.Devices.isBrowserSupported()
    const isEnvSupported = window.tccc.isEnvSupported()
    if (!isBrowserSupported || !isEnvSupported) {
      reject('当前浏览器暂不支持腾讯云呼叫')
    }
    resolve()
  })

  const phoneCheck = new Promise((resolve, reject) => {
    const msg = '没有麦克风设备'
    window.tccc.Devices.getMicrophones()
      .then((res = []) => {
        if (res.length) {
          resolve()
        } else {
          reject(msg)
        }
      })
      .catch(() => {
        reject(msg)
      })
  })

  const speakerCheck = new Promise((resolve, reject) => {
    const msg = '没有扬声器设备'
    window.tccc.Devices.getSpeakers()
      .then((res = []) => {
        if (res.length) {
          resolve()
        } else {
          reject(msg)
        }
      })
      .catch(() => {
        reject(msg)
      })
  })
  return new Promise((resolve, reject) => {
    Promise.all([envCheck, phoneCheck, speakerCheck, empowerMedio])
      .then(() => {
        resolve()
      })
      .catch(error => {
        Message.error(error)
        reject()
      })
  })
}
const injectTcccWebSDK = SdkURL => {
  if (window.tccc) {
    console.warn('已经初始化SDK了，请确认是否重复执行初始化')
    return
  }
  return new Promise((resolve, reject) => {
    const scriptDom = document.createElement('script')
    scriptDom.setAttribute('crossorigin', 'anonymous')
    scriptDom.src = SdkURL
    document.body.appendChild(scriptDom)
    scriptDom.addEventListener('load', () => {
      // 加载JS SDK文件成功，此时可使用全局变量"tccc"
      // ready事件必须监听，否则容易发生tccc不存在的错误，所有呼入呼出的逻辑必须在ready事件触发后才可以调用
      window.tccc.on(window.tccc.events.ready, () => {
        window.tccc.UI.hide()
        /**
         * Tccc SDK初始化成功，此时可调用外呼等功能。
         * 注意⚠️：请确保只初始化一次SDK
         * */
        resolve('初始化成功')
      })
      window.tccc.on(window.tccc.events.tokenExpired, ({ message }) => {
        console.error('初始化失败', message)
        reject(message)
      })
      //监听呼入事件
      window.tccc.on(window.tccc.events.callIn, options => {
        console.log('监听到电话呼入：', options)
        sessionId = options.sessionId
        getCallerInfo({ phone: options.phone })
          .then(res => {
            const { callerName, callerType, callerId, callerUcUserId, extendInfo } = res
            const userType = roleMap[callerType]
            if (!isSessionIdVoild()) return
            store.commit('tccc/SET_TCCC_USERINFO', {
              name: callerName,
              userType,
              callerType,
              phone: options.phone,
              header: headerObj[userType],
              userId: callerId,
              ucUserId: callerUcUserId,
              extendInfo,
              options,
              action: 2 //1呼出，2呼入
            })
            store.commit('tccc/SET_TCCC_STATUS', 'Answer')
          })
          .catch(res => {
            console.log(res)
          })
      })
      // 监听会话结束事件
      window.tccc.on(window.tccc.events.sessionEnded, options => {
        console.log('监听到会话结束：', options)
        options?.sessionId === sessionId ? (sessionId = '') : ''
        store.commit('tccc/SET_TCCC_STATUS', 'RingOff')
        store.commit('tccc/SET_TCCC_USERINFO', {})
      })
      // 外呼成功事件
      window.tccc.on(window.tccc.events.callOuted, options => {
        console.log('监听到外呼成功事件：', options)
        store.commit('tccc/SET_TCCC_STATUS', 'RingOn')
      })
      // 外呼对方接听事件
      window.tccc.on(window.tccc.events.calloutAccepted, options => {
        console.log('监听到对方接听：', options)
        store.commit('tccc/SET_TCCC_STATUS', 'Accept')
      })
    })
  })
}
// 电话呼出
export const callOut = async (params, userInfo) => {
  // NOTE: 0-坐班中接收 1-休息中 2-坐班中拒收
  if (store.state.user.workStatus) {
    return message.warn('监测到目前坐班状态为休息，无法操作！')
  }
  let res = {}
  try {
    if (stutas.value === 'init') {
      isBindPhone()
    } else {
      await checkDevicesIsOK()
      res = await handleCallOut(params, userInfo)
    }
  } catch (error) {
    console.log('设备检测异常', error)
  }
  return res
}
/**
 * 真正发起外呼前，并行尝试把该患者加入主动回访池
 * 仅患者场景调用；是否真正加入由后端判断，失败不阻断拨打
 * calleeType 1-患者 2-医生
 */
const tryJoinActiveFollowup = params => {
  const calleeType = Number(params?.calleeType)
  if (![-1, 1].includes(calleeType) || !params?.calleeUcUserId) return Promise.resolve()
  return joinActiveFollowupPairs({
    items: [{ ucPatientId: params.calleeUcUserId, ucDoctorId: params.ucDoctorId || 0 }],
    // assignedBy=0 表示自己加入，daUcUserId 为当前登录健管
    assignedBy: 0,
    daUcUserId: store.getters.userId
  }).catch(() => {
    // 失败不阻断拨打
  })
}

const handleCallOut = async (params, userInfo) => {
  // 请求 TCCC 前，先尝试加入主动回访池，无论成功失败都继续后续拨打流程
  await tryJoinActiveFollowup(params)
  return new Promise((resolve, reject) => {
    //调用api之前需要先判断一下是否已经初始化成功
    getSkillGroupId(params).then(res => {
      // debugger
      const { phone, skillGroupId, cdrId, headUrl } = res
      // userInfo.header = userInfo.header || headUrl
      userInfo.header = headUrl || headerObj[userInfo.userType]
      if (!phone) {
        const tips = `该${userInfo.userType}未登记有效手机号，暂时无法拨打`
        Modal.warning({
          centered: true,
          title: () => '提示',
          content: () => tips
        })
        reject(false)
        return false
      }
      // cdr_Id.value = cdrId
      store.commit('tccc/SET_CDR_ID', cdrId)
      resolve(res)
      const options = {
        phoneNumber: phone,
        skillGroupId: skillGroupId,
        uui: `${cdrId}`
      }
      window.tccc.Call.startOutboundCall(options)
        .then(res => {
          console.log('电话呼出', res, userInfo, res)
          sessionId = res.data.sessionId
          store.commit('tccc/SET_TCCC_STATUS', 'Calling')
          store.commit('tccc/SET_TCCC_USERINFO', {
            ...userInfo,
            calleeType: params.calleeType,
            phone: res.data.calleePhoneNumber,
            // 避免 0086 开头
            calleePhoneNumberText: res.data.calleePhoneNumberText,
            action: 1 //1呼出，2呼入
          })
        })
        .catch(res => {
          const status = window.tccc.Agent.getStatus()
          const isOffline = status === 'offline'
          const msg = isOffline ? `${res.errorMsg},是否重新连接？` : res.errorMsg
          if (isOffline) {
            Modal.confirm({
              title: () => '提示',
              icon: () => createVNode(ExclamationCircleOutlined),
              content: () => res.errorMsg + ',是否重新连接？',
              centered: true,
              onOk() {
                window.tccc.Agent.online()
              },
              onCancel() {
                console.log('Cancel')
              }
            })
          } else {
            Message.error(msg)
          }
        })
    })
  })
}
export const callIn = async () => {
  try {
    if (stutas.value === 'init') {
      isBindPhone()
    } else {
      await checkDevicesIsOK()
      if (!isSessionIdVoild()) return
      //唤起来电提醒窗口，接听电话调用下方api
      window.tccc.Call.accept({ sessionId })
        .then(() => {
          //电话呼入之后的操作
          console.log('接听', sessionId)
          store.commit('tccc/SET_TCCC_STATUS', 'Pending')
        })
        .catch(res => {
          Message.error(res.errorMsg)
          hungUp()
        })
    }
  } catch (error) {
    console.log('设备检测异常', error)
  }
}
// 转接会话
// NOTE: https://cloud.tencent.com/document/product/679/72044#.E8.BD.AC.E6.8E.A5.E4.BC.9A.E8.AF.9D
export const callTransfer = async params => {
  const { ivrKey, userId } = params
  let data = {}
  if (userId) {
    //转接到指定座席
    data = {
      // 指定会话 ID
      sessionId,
      userId
    }
  } else {
    const skillGroupId = await getSkillGroup({ ivrKey })
    data = {
      // 指定会话 ID
      sessionId,
      skillGroupId
    }
  }
  window.tccc.Call.transfer(data)
    .then(result => {
      console.log('Call.transfer', result)
    })
    .catch(err => {
      console.log('Call.transfer', err)
      message.error(err.errorMsg)
    })
}

export const hungUp = (showMsg = true) => {
  if (stutas.value === 'init') {
    isBindPhone()
  } else {
    if (!isSessionIdVoild(showMsg)) return
    //唤起来电提醒窗口，挂断电话调用下方api
    window.tccc.Call.hungUp({ sessionId })
      .then(() => {
        console.log('挂断', sessionId)
        sessionId = ''
        store.commit('tccc/SET_TCCC_STATUS', 'RingOff')
        store.commit('tccc/SET_TCCC_USERINFO', {})
      })
      .catch(res => {
        console.log(res.errorMsg)
      })
  }
}
// 判断是否绑定虚拟坐席
const isBindPhone = () => {
  const ucUserId = store.getters.userId
  isRegisterPhone({ ucUserId }).then(res => {
    if (res) {
      Message.error('云电话还未初始化，电话无法呼出/接入')
    } else {
      Modal.warning({
        centered: true,
        title: () => '提示',
        content: () => '未绑定虚拟电话坐席，请联系您所在的部门负责人'
      })
    }
  })
}
const empowerMedio = new Promise((resolve, reject) => {
  const constrains = { audio: true }
  const msg = '请授权麦克风！'
  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    navigator.mediaDevices
      .getUserMedia(constrains)
      .then(stream => {
        console.log(stream)
        resolve()
      })
      .catch(err => {
        console.log(err)
        reject(msg)
      })
  } else {
    var getUserMedia =
      navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia ||
      navigator.oGetUserMedia
    if (!getUserMedia) {
      reject('你的浏览器不支持访问用户媒体设备')
    } else {
      getUserMedia(constrains)
        .then(stream => {
          console.log(stream)
          resolve()
        })
        .catch(err => {
          console.log(err)
          reject(msg)
        })
    }
  }
})
// 检测并发情况下，sessionId是否存在
const isSessionIdVoild = (showMsg = true) => {
  if (!sessionId) {
    showMsg && Message.error('对方已取消呼叫')
    store.commit('tccc/SET_TCCC_STATUS', 'RingOff')
    store.commit('tccc/SET_TCCC_USERINFO', {})
    return false
  } else {
    return true
  }
}
